const zh = {
	accountCenter: {
		myAccount: '提现账户',
		withdrawalAccounts: '总计：',
		withdrawalAccountsSub: '，审核通过：',
		pending: '审核中',
		fail: '审核失败',
		see: '查看',
		safeCenter: '安全中心',
		password: '登录密码',
		phone: '绑定手机',
		email: '绑定邮箱',
		keySetting: '密钥设置',
		changePassword: '修改登录密码',
		changePhone: '更换绑定手机号',
		bindEmail: '绑定邮箱',
		changeEmail: '更换绑定邮箱',
		saltSetting: '密钥设置',
		setting: '设置',
		passwordDesc: '密码强度越高，账号安全级别越高，不易被非法利用',
		phoneDesc: '安全验证，提现更改收益账户时将会通过发送手机短信验证码方式进行',
		emailDesc:
      '作为您的登录邮箱，找回密码以及其他验证操作也将通过邮件发送到此邮箱',
		saltDesc: '请勿轻易泄漏密钥信息'
	},
	password: {
		accountCenter: '账号中心',
		modifyLoginPassword: '修改登录密码',
		oldPassword: '原登录密码',
		newPassword: '新登录密码',
		again: '再次输入新密码',
		phoneCode: '手机验证码（短信将发送至',
		comfirm: '确认',
		oldpasswordMsg: '请输入原登录密码',
		newPasswordMsg: '请输入新登录密码',
		newPasswordAgain: '请再次输入密码',
		differPassword: '密码不匹配。',
		saftyCode: '请输入安全验证码',
		passwordSuccess: '密码修改成功',
		codeOverTime: '验证码超时',
		codeError: '验证码错误',
		oldPasswordError: '原密码错误',
		unknownError: '未知错误，登录密码修改失败',
		tip: '温馨提示：为保证您的账户安全，请每隔90天修改您的登录密码',
		usTip:
      '为保证您的账户安全，请每隔90天修改您的登录密码，密码修改后会在PingPong旗下其他业务同步变更',
		passwordMsg:
      '密码强度：弱，密码需包含大写字母、小写字母、数字，且不少于8位',
		numberLetters: '密码必须是数字和字母的组合，不包含空格、特殊字符',
		incorrectPwd: '密码不符合规则'
	},
	phone: {
		modifyBindPhone: '更换绑定手机',
		newPhone: '新手机号码',
		validateWay: '验证方式',
		phoneValidate: '手机验证',
		emailValidate: '邮箱验证',
		oldPhoneCode: '原手机验证码（短信将发送至',
		oldEmailCode: '邮箱验证码（验证码将发送至',
		tip: '温馨提示：当您变更手机号后会在PingPong旗下其他业务同步变更',

		newPhoneMsg: '请输入新手机号码',
		newPhoneCode: '请输入新手机验证码',
		emailCode: '请输入邮箱验证码',
		emailSuccess: '绑定邮箱修改成功',
		oldPhoneError: '原手机号码错误',
		phoneRegister: '该新手机号已被注册',
		unknownError: '未知错误，绑定手机号码修改失败！',
		phoneSuccess: '绑定手机号修改成功'
	},
	email: {
		modifyBindEmail: '更换绑定邮箱',
		newEmail: '新邮箱地址',
		newEmailCode: '新邮箱验证码',
		phoneCode: '手机验证码（短信将发送至',
		newEmailMsg: '请输入新邮箱地址',
		emailCode: '请输入新邮箱验证码',
		phoneCodeMsg: '请输入手机验证码',
		emailRegister: '该新邮箱已被注册',
		unknowmError: '未知错误，绑定邮箱修改失败！',
		tip: '温馨提示：当您变更邮箱后会在PingPong旗下其他业务同步变更'
	},
	salt: {
		saltSetting: '密钥管理',
		storeName: '网站',
		omniStoreName: '门店/网站',
		accId: '网站ID',
		omniAccId: '门店/网站ID',
		export: '导出密钥',
		search: '搜索',
		reset: '重置',
		type: '加密类型',
		apiStatus: 'API 状态',
		updateTime: '更新时间',
		operation: '操作',
		saltDetail: '密钥详情',
		salt: '密钥',
		copy: '复制',
		freshenSalt: '刷新密钥',
		freshenSaltTip:
      '注意：密钥一旦重新设置，商户系统的请求，则需要用使用新的密钥才能和系统完成交互。请谨慎操作。',
		freshenSuccess: '秘钥刷新成功',
		latestSalt: '最新密钥',
		timeOut: '验证码超时',
		codeError: '验证码错误',
		unknownError: '未知错误',
		cancel: '取消',
		normal: '正常',
		abnormal: '异常'
	},
	tradeType: '贸易类型',
	tradeTypeOptions: {
		Service: '服务贸易',
		Goods: '货物贸易',
		Digital: '虚拟商品/服务',
		ServiceGoods: '服务或货物'
	},
	identityVerificationApproved: '实名已认证'
}

export default zh
